import React, { useEffect } from "react";
import { useMusicApi } from "../../api/useMusicApi";
import { Card } from "../../components/Card/Card";
import { CardBody } from "../../components/Card/CardBody";
import { Table } from "../../components/Table/Table";
import { CardContentPreloader } from "../../components/Card/CardContentPreloader";
import { PaginationComponent } from "../../components/Pagination";
import { tracksColumnsDefinition } from "./TracksColumnDefinition";
import { useApiExecutor } from "../../hooks/useApiExecutor";
import { TracksFilters } from "./TracksFilters";
import { useGenres } from "../../hooks/use-genres";
import { usePageHelper } from "../../hooks/use-page-helper";

type Props = {
  onChange: (totalCount: number | string, currentCount: number) => void;
};

export const Tracks: React.FC<Props> = ({ onChange }) => {
  const api = useMusicApi();
  const { t } = usePageHelper("tracks");
  const { genres } = useGenres();
  const { contents, info, fetch, fetchPage } = useApiExecutor({
    fetchCallback: api.getTracks,
    showInPage: 50,
  });

  useEffect(() => {
    onChange(info.allContentCounts ?? 0, info.contentsCountWithOffset);
  }, [info?.allContentCounts, info?.contentsCountWithOffset]);

  return (
    <>
      <TracksFilters className={"mb-3"} onApply={fetch} />
      <Card>
        <CardBody>
          {info?.isPageLoading || info?.isInitialLoading ? (
            <CardContentPreloader />
          ) : (
            <Table
              data={contents}
              columnsDefinition={tracksColumnsDefinition(t as any, genres)}
            />
          )}
        </CardBody>
      </Card>
      <br />
      {!info?.isPageLoading && !info.isInitialLoading && (
        <PaginationComponent threshold={10} info={info} onChange={fetchPage} />
      )}
    </>
  );
};
